import { useIntl } from 'react-intl'
import Box from 'components/shared/Box'
import Select from 'components/shared/Select'
import { SelectWrapper } from './styles'
import { useResolutions } from 'store/resolutions'
import BungalowWrapper from 'components/shared/BungalowWrapper'
import { BungalowInfo } from 'store/accommodation-slice'

export interface BungalowDataProps {
    adults: number
    kids: number
    infants: number
}

const selectOptions = Array.from({ length: 9 }).map((_, index) => ({
    option: `${index}`,
}))

interface BungalowProps {
    index: number
    values: BungalowInfo
    isDeleteVisible: boolean
    adultsRange?: number
    kidsRange?: number
    infantsRange?: number
    handleDelete: (indexToDelete: number) => void
    updateBungalow: (index: number, bungalow: BungalowDataProps) => void
}

const Bungalow = ({
    index,
    values,
    isDeleteVisible,
    adultsRange = 8,
    kidsRange = 7,
    infantsRange = 7,
    handleDelete,
    updateBungalow,
}: BungalowProps) => {
    const { formatMessage } = useIntl()
    const { isTablet } = useResolutions()

    const adults = values.adults.length
    const kids = values.kids.length
    const infants = values.infants.length

    return (
        <BungalowWrapper
            index={index}
            isDeleteVisible={isDeleteVisible}
            handleDelete={() => handleDelete(index)}
        >
            <Box
                direction={['column', 'row']}
                gap={[24, 16]}
                isFullWidth={isTablet}
            >
                <SelectWrapper isFullWidth>
                    <Select
                        value={adults.toString()}
                        options={selectOptions.slice(0, adultsRange + 1)}
                        id="adults-accomodation"
                        label={formatMessage({
                            id: 'global.input.adult_label',
                            defaultMessage: 'Dorosły',
                        })}
                        onChange={(option: string) =>
                            updateBungalow(index, {
                                adults: +option,
                                kids,
                                infants,
                            })
                        }
                        hasNoMaxWidth
                        testId={`accommo-${index}-select-adults`}
                    />
                </SelectWrapper>

                <SelectWrapper isFullWidth>
                    <Select
                        value={kids.toString()}
                        options={selectOptions.slice(0, kidsRange + 1)}
                        id="kids-accomodation"
                        label={formatMessage({
                            id: 'global.input.child_under_12_label',
                            defaultMessage: 'Dziecko (do 12 lat)',
                        })}
                        onChange={(option: string) =>
                            updateBungalow(index, {
                                adults,
                                kids: +option,
                                infants,
                            })
                        }
                        hasNoMaxWidth
                        testId={`accommo-${index}-select-kids`}
                    />
                </SelectWrapper>
                <SelectWrapper isFullWidth>
                    <Select
                        value={infants.toString()}
                        options={selectOptions.slice(0, infantsRange + 1)}
                        id="small-kids-accommodation"
                        label={formatMessage({
                            id: 'global.input.child_under_3_label',
                            defaultMessage: 'Dziecko (do 3 lat)',
                        })}
                        onChange={(option: string) =>
                            updateBungalow(index, {
                                adults,
                                kids,
                                infants: +option,
                            })
                        }
                        hasNoMaxWidth
                        testId={`accommo-${index}-select-infants`}
                    />
                </SelectWrapper>
            </Box>
        </BungalowWrapper>
    )
}

export default Bungalow
